import { z } from "zod";
import { unitArray } from "../../../units";
import { ZodStringNullable } from "../../zod-types/zod-string-nullable";

export const patchPartnershipNumericAgreementSchema = z
	.object({
		value: z.number(),
		note: ZodStringNullable,
		startDate: z.string(),
		unit: z.enum(unitArray),
	})
	.superRefine((data, ctx) => {
		if (data.unit === "days")
			ctx.addIssue({
				code: "custom",
				path: ["unit"],
				message: "Select unit",
			});
	});

export const patchPartnershipNumericAgreementQuerySchema = z.object({
	agreementId: z.string().optional(),
});

export type PatchPartnershipNumericAgreementSchema = z.infer<
	typeof patchPartnershipNumericAgreementSchema
>;

export type PatchPartnershipNumericAgreementQuerySchema = z.infer<
	typeof patchPartnershipNumericAgreementQuerySchema
>;
